var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("sidebar-widget", {
    attrs: {
      title: _vm.$gettext("Suche"),
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function fn() {
          return [
            _c(
              "form",
              {
                staticClass: "sidebar-search",
                on: {
                  submit: function submit($event) {
                    $event.preventDefault()
                  },
                },
              },
              [
                _c(
                  "ul",
                  {
                    staticClass: "needles",
                  },
                  [
                    _c("li", [
                      _c(
                        "div",
                        {
                          staticClass: "input-group files-search",
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.searchTerm,
                                expression: "searchTerm",
                              },
                            ],
                            attrs: {
                              type: "text",
                              "aria-label": _vm.$gettext(
                                "Geben Sie einen Suchbegriff mit mindestens 3 Zeichen ein."
                              ),
                            },
                            domProps: {
                              value: _vm.searchTerm,
                            },
                            on: {
                              input: function input($event) {
                                if ($event.target.composing) return
                                _vm.searchTerm = $event.target.value
                              },
                            },
                          }),
                          _vm._v(" "),
                          _vm.showSearchResults
                            ? _c(
                                "a",
                                {
                                  staticClass: "reset-search",
                                  on: {
                                    click: function click($event) {
                                      $event.preventDefault()
                                      return _vm.setShowSearchResults(false)
                                    },
                                  },
                                },
                                [
                                  _c("studip-icon", {
                                    attrs: {
                                      shape: "decline",
                                      size: 20,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "submit-search",
                              attrs: {
                                type: "submit",
                                value: _vm.$gettext("Suchen"),
                                "aria-controls": "search",
                              },
                              on: {
                                click: _vm.loadResults,
                              },
                            },
                            [
                              _c("studip-icon", {
                                attrs: {
                                  shape: "search",
                                  size: 20,
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }